// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"cQ-z","upvoteIcon":"dQ-z","downvoteIcon":"eQ-z","feedbackIcon":"fQ-z"};